import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

const initialState = {
  caricamentoInCorso: false,
  documenti: [],
  clienti: [],
};

const documentiSlice = createSlice({
  name: 'documenti',
  initialState,
  reducers: {
    caricamento(state, action) {
      state.caricamentoInCorso = !!action.payload;
    },
    aggiornaDocumenti(state, action) {
      state.documenti = action.payload;
    },
    aggiornaClienti(state, action) {
      state.clienti = _.uniq(action.payload);
    },
  },
});

export const { caricamento, aggiornaDocumenti, aggiornaClienti } = documentiSlice.actions;
const documentiReducer = documentiSlice.reducer;

export default documentiReducer;
